import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

import {
  IAnchorRegistry,
  IWalkthroughNavigator,
  IWalkthroughRenderer,
} from './ports';

export const HELP_DOCUMENT_ROUTE_TOKEN = new InjectionToken<string>(
  'help-document-route'
);

export interface PageHelpServicePort {
  hasHelpForCurrentPage(): Observable<boolean>;
  openPageHelpDialog(): void;
}

export const PAGE_HELP_SERVICE = new InjectionToken<PageHelpServicePort>(
  'page-help-service'
);

/**
 * The three platform seams the walkthrough player is written against. Web binds
 * driver.js, the DOM, and the Angular router; NativeScript binds a native overlay,
 * a view registry, and a tab-aware navigator.
 */
export const WALKTHROUGH_RENDERER = new InjectionToken<IWalkthroughRenderer>(
  'walkthrough-renderer'
);

export const WALKTHROUGH_ANCHOR_REGISTRY = new InjectionToken<IAnchorRegistry>(
  'walkthrough-anchor-registry'
);

export const WALKTHROUGH_NAVIGATOR = new InjectionToken<IWalkthroughNavigator>(
  'walkthrough-navigator'
);
